import { ref } from 'vue'
import { CardInterface } from '@/interfaces/CardInterface'
import { reserveService } from "@/services/reserve.service";
import { useStore } from "vuex";
import { key } from "@/setup/store";
import sleep from '@/utils/Sleep';

export default function useCardTurnos() {

  const cards = ref<CardInterface[]>([])
  const currentSelectedCards = ref<CardInterface>()
  const error = ref(false)
  const loading = ref(true)
  const { state } = useStore(key)

  const fetchCard = async (actividadId: number, dayId?: number, conAccesoVip?: boolean | null) => {
    try {
      /**
       * Iniciamos  siemrpe el loading que se ejecuta esta
       * funicion, ya que implica carga de datos
       */
      error.value = false
      loading.value = true
      cards.value = []
      if (actividadId && dayId) {
        await sleep(1)
        cards.value = await reserveService.listar(actividadId, dayId, state.navigation.vehiculo?.id, conAccesoVip)
      }
    } catch (err) {
      error.value = true
    } finally {
      /**
       * sacamos el loading, pero siempre al final de loa peticion antes
       */
      loading.value = false
    }
  }

  const cardSelected = (id: number) => {
    cards.value.map(card => {
      card.selected = card.id === id
      return card
    })
    verifySelectedCard()
  }

  const deselectAllSelected = () => {
    cards.value.map(card => {
      card.selected = false
      return card
    })
    verifySelectedCard()
  }

  const verifySelectedCard = () => {
    cards.value.forEach(card => {
      if (card.selected) {
        currentSelectedCards.value = card
      }
    })
  }


  return {
    cards,
    cardSelected,
    currentSelectedCards,
    deselectAllSelected,
    error,
    loading,
    fetchCard
  }
}